export function isUpperCase(str) {
  // returns true if there's 4 capital letters in a row
  return !!/[A-Z]{4}/.exec(str)
}
